// CONTEXTS
import { useVideoPlayerRefs } from "../../contexts/VideoPlayerRefs";
import { useRoot } from "../../contexts/Root";

// TYPES
import { Controls } from "../../types/controls";

import styles from "./styles.module.css";

export const VideoElement = () => {
  const { aspectRatio, loop, autoplay, controls } = useRoot();
  const { video } = useVideoPlayerRefs();

  const style = {
    aspectRatio,
  };

  return (
    <div className={styles.container} style={style}>
      <video
        crossOrigin="anonymous"
        className={styles.video}
        controls={controls === Controls.native}
        ref={video}
        loop={loop}
        muted
        poster={undefined}
        autoPlay={autoplay}
        preload="auto"
        playsInline
      />
    </div>
  );
};
